import React from "react";
import PropTypes from "prop-types";

import { useMounted } from "../../hook/useMounted";
import "./KakaoPayPromotionBanner.css";
import IconKakaoPayLogo from "./assets/kakaopay_logo.png";
import IconChevronRight from "./assets/chevron-smaller-right.svg";

/**
 * 카카오페이 결제 프로모션 배너
 * @param {"gallery"|"inline"|"checkout"} type - "gallery": 모바일/태블릿에서 이미지 갤러리 바로 아래 엣지투엣지 배치,
 *                                    "inline": PC에서 상세 영역 안전결제 배너 위 카드 배치(8px border-radius),
 *                                    "checkout": 결제 페이지 결제수단 영역 카드 배치(8px border-radius)
 * @returns {JSX.Element}
 * @constructor
 */
export default function KakaoPayPromotionBanner({ type }) {
  const isMounted = useMounted();

  return (
    <a
      className={`KakaoPayPromotionBanner KakaoPayPromotionBanner--${type}`}
      href="https://intercom.help/fruits-family-co/ko/articles/16612792"
      rel="noopener noreferrer"
      target="_blank"
    >
      <div className="KakaoPayPromotionBanner-content">
        <div className="KakaoPayPromotionBanner-logo">
          {/* kakaopay_logo.png는 4KB 미만이라 Vite가 base64로 인라인해서 manifest에 엔트리가 없다.
              SSR(server/register.js)은 manifest 엔트리로만 asset URL을 찾기 때문에 SSR 렌더링 시에는
              src가 null이 되어 마운트 이후(CSR)에만 렌더링한다. */}
          {isMounted && <img alt="kakaopay" src={IconKakaoPayLogo} />}
        </div>
        <p className="KakaoPayPromotionBanner-text">
          카카오페이머니로 결제 시 최대 5천원 즉시할인
        </p>
      </div>
      <img alt="" src={IconChevronRight} />
    </a>
  );
}

KakaoPayPromotionBanner.propTypes = {
  type: PropTypes.oneOf(["gallery", "inline", "checkout"]).isRequired,
};
